import { ResourcefulReducer } from '../../util';
import WidgetModel from '../models/widget_model';

const WidgetReducer = new ResourcefulReducer('widget', WidgetModel);

global.widget_reducer = WidgetReducer;

export default WidgetReducer;
